export const shippingOptions: ShippingOption[] = [
    {
        id: 'standard',
        label: 'Standard',
        description: '5-7 business days',
        stripe_price_id: '',
        price: 0,
        value: 'standard',
        country: 'US',
    },
    {
        id: 'expedited',
        label: 'Expedited',
        stripe_price_id: 'price_1OUdrnIDrm6Z6HgYj6juDNMy',
        description: '2-3 business days',
        price: 1995,
        value: 'expedited',
        country: 'US',
    },
    {
        id: 'bat_attachment_ca',
        label: 'Canada Standard - Bat Attachment',
        stripe_price_id: 'price_1Q8qP9IDrm6Z6HgYSOKPEdXz',
        description: '10-14 days',
        price: 1295,
        value: 'standard',
        country: 'CA',
        for_category: ['bat_attachment'],
    },
    {
        id: 'bat_attachment_bruce_bolt_ca',
        label: 'Canada Standard - Bat Attachment + Other Items in a Single Box',
        stripe_price_id: 'price_1Q8qQ4IDrm6Z6HgY8ZHYOpbE',
        description: '10-14 days',
        price: 1495,
        value: 'standard',
        country: 'CA',
        for_category: [],
    },
    {
        id: 'short_bat_ca',
        label: 'Canada Standard - Short Bat',
        stripe_price_id: 'price_1Q8qNDIDrm6Z6HgYQotktdlx',
        description: '10-14 days',
        price: 1195,
        value: 'standard',
        country: 'CA',
        for_category: ['short_bat'],
    },
    {
        id: 'short_bat_other_items_ca',
        label: 'Canada Standard - Short Bat + Other Items in a Single Box',
        stripe_price_id: 'price_1Q8qOOIDrm6Z6HgYJZBDtBhX',
        description: '10-14 days',
        price: 4495,
        value: 'standard',
        country: 'CA',
        for_category: [],
    },
    {
        id: 'bat_attachment_mx',
        label: 'Mexico Standard - Bat Attachment',
        stripe_price_id: 'price_1Q8qgfIDrm6Z6HgYxaAfN5fx',
        description: '10-14 days',
        price: 1495,
        value: 'standard',
        country: 'MX',
        for_category: ['bat_attachment'],
    },
    {
        id: 'bat_attachment_bruce_bolt_mx',
        label: 'Mexico Standard - Bat Attachment + Other Items in a Single Box',
        stripe_price_id: 'price_1Q8qgyIDrm6Z6HgYKD8TQg2h',
        description: '10-14 days',
        price: 2995,
        value: 'standard',
        country: 'MX',
        for_category: [],
    },
    {
        id: 'short_bat_mx',
        label: 'Mexico Standard - Short Bat',
        stripe_price_id: 'price_1Q8qfsIDrm6Z6HgY5EQKCnQj',
        description: '10-14 days',
        price: 2995,
        value: 'standard',
        country: 'MX',
        for_category: ['short_bat'],
    },
    {
        id: 'short_bat_other_items_mx',
        label: 'Mexico Standard - Short Bat + Other Items in a Single Box',
        stripe_price_id: 'price_1Q8qgJIDrm6Z6HgYfY4iMqeK',
        description: '10-14 days',
        price: 6995,
        value: 'standard',
        country: 'MX',
        for_category: [],
    },
]

export default shippingOptions